import React, { useRef } from 'react'
import Declarar from '../components/Home/Declarar'
import Empezar from '../components/Home/Empezar'
import Hero from '../components/Home/Hero'
import Mejor from '../components/Home/Mejor'
import Preguntas from '../components/Home/Preguntas'
import Prices from '../components/Home/Prices'
import HomeNav from '../components/navber/HomeNav'

const HomePage = () => {

  const projectRef = useRef(null);
  const aboutRef = useRef(null);
  const reviewsRef = useRef(null);

  const scrollSection = (elementRef) => {
    window.scrollTo({
      top: elementRef.current.offsetTop,
      behavior: "smooth",
    });
  };



  return (
    <div>
        <HomeNav scrollSection={scrollSection} projectRef={projectRef} aboutRef={aboutRef} reviewsRef={reviewsRef}/>
        <Hero/>
        <Declarar projectRef={projectRef}/>
        <Prices projectRef={aboutRef}/>
        <Mejor/>
        <Empezar/>
        <Preguntas reviewsRef={reviewsRef}/>
    </div>
  )
}

export default HomePage